// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_SERVICE_ACCOUNT } from "./action";

export function canCreateServiceAccount(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_SERVICE_ACCOUNT);
}
